// Creator web visibility (docs/creator-web-visibility.md): admin-only switch that
// hides a creator from the public website without touching the app or dashboard.
// Presentational: the caller owns the value and the write (immediate on the Users
// page, deferred to Save in the user form).
export default function WebVisibilitySwitch({ isPrivate, onToggle, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!isPrivate}
      aria-label={label}
      title={isPrivate ? "Hidden from the public website" : "Visible on the public website"}
      onClick={() => onToggle(!isPrivate)}
      className="inline-flex items-center gap-2 text-xs font-medium focus:outline-none"
    >
      <span
        className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full transition-colors duration-150 ${
          isPrivate ? "bg-gray-300" : "bg-green-500"
        }`}
      >
        <span
          className={`inline-block h-4 w-4 mt-0.5 rounded-full bg-white shadow transform transition-transform duration-150 ${
            isPrivate ? "translate-x-0.5" : "translate-x-4"
          }`}
        />
      </span>
      <span className={isPrivate ? "text-gray-500" : "text-green-700"}>
        {isPrivate ? "Private" : "Public"}
      </span>
    </button>
  );
}
